import cls from 'classnames';
import { isFunction } from 'is-all-utils';
import React, { FC, useEffect, useState } from 'react';
import like from '../images/like.png';
import generateColor from '../utils/generate-color';
import lightenColor from '../utils/lighten-color';

interface Props
   extends React.DetailedHTMLProps<
      React.HTMLAttributes<HTMLDivElement>,
      HTMLDivElement
   > {
   color?: string;
   index: string | number;
   dispatch?: any;
}

const Palette: FC<Props> = (props) => {
   const { ...morePropsOld } = props;
   const {
      className,
      index,
      color: oldColor,
      dispatch,
      ...moreProps
   } = morePropsOld;
   const [color, setColor] = useState<any>('');
   const [colors, setColors] = useState<any[]>([]);
   const [isLike, setIsLike] = useState(false);
   const [id, setId] = useState<string>('');
   // const id = 'pacolor-' + color;

   useEffect(() => {
      const newColor = oldColor || generateColor();
      setColor(newColor);

      setColors([
         lightenColor(newColor, 0),
         lightenColor(newColor, 10),
         lightenColor(newColor, 20),
         lightenColor(newColor, 30),
      ]);

      const newId = 'pacolor-' + newColor;
      const storage = localStorage.getItem(newId);
      if (storage) {
         setIsLike(true);
      }
      setId(newId);
      // eslint-disable-next-line
   }, []);

   const onLike = () => {
      if (isLike) {
         localStorage.removeItem(id);
         setIsLike(false);
         isFunction(dispatch) &&
            dispatch({
               type: 'delete',
               payload: color,
            });
      } else {
         localStorage.setItem(id, color);
         setIsLike(true);
      }
   };

   return (
      <div
         className={`palette ${className}`}
         {...moreProps}
         style={{
            border: `2px solid ${color}`,
         }}
      >
         <div className="palette-colors">
            {colors.map((v, i) => {
               const itemkey = 'item-' + index + '-' + i;
               return (
                  <div
                     key={i + '-item'}
                     className={`palette-item fadeInRight ${itemkey}`}
                     style={{
                        background: v,
                     }}
                     onClick={() => {
                        const nodeItem = document.querySelector<
                           HTMLSpanElement
                        >(`.${itemkey}`);
                        const itemText = nodeItem?.children[0];
                        if (nodeItem && itemText) {
                           itemText.textContent = 'Copied !';
                           nodeItem.classList.add('copied');
                           setTimeout(() => {
                              itemText.textContent = v;
                              nodeItem.classList.remove('copied');
                           }, 800);
                           var input = document.createElement('input');
                           input.setAttribute('value', v);
                           document.body.appendChild(input);
                           input.select();
                           // eslint-disable-next-line
                           var result = document.execCommand('copy');
                           document.body.removeChild(input);
                        }
                     }}
                  >
                     <span>{v}</span>
                  </div>
               );
            })}
         </div>
         <div className="actions">
            <button
               className={cls({
                  liked: isLike,
               })}
               onClick={onLike}
            >
               <img src={like} alt="" />
            </button>
         </div>
      </div>
   );
};

export default Palette;
